import * as React from 'react';
import { G, Path } from 'react-native-svg';

function HeadbandYellow() {
  return (
    <G
      fill="#ecce3c"
      stroke="#cbb610"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.72}
    >
      <Path d="M32.13 63.76c-1.62 2.48-.62 5.95 1.22 6.38a5.42 5.42 0 002.33-.14 201.57 201.57 0 0148.4-3.82c6.76.28 13.57.9 20.24-.22 1.84-.31 4.17-1.65 3.45-3.37-.44-1.07-1.81-1.34-3-1.45a580.13 580.13 0 00-67.34-2.69 7.62 7.62 0 00-4.31.95c-1.22.87-1.75 2.84-.66 3.86a3.29 3.29 0 002.9.61c10.25-2.22 25.43-1.33 37.89-.95" />
      <Path d="M106.19 65.75c1.37-.65 2.57-2.33 1.75-3.61a3.49 3.49 0 00-2.6-1.16c-2.37-.31-5.08-.87-6.2-3a6.32 6.32 0 01-.6-2.55 18.47 18.47 0 01.76-6.53c.09 1.57 1.4 2.78 2.69 3.68s2.73 1.77 3.39 3.21.34 3.42 1.17 4.9c.18.31.48.62.83.56a1 1 0 00.54-.38 11.52 11.52 0 0115-1.13 58.8 58.8 0 01-8.78 3c-2.75.11-5-.88-7.6-1.64-6.85-2.03-5.42 7.05-.35 4.65zM73.29 62.92c2.39-.23 25.37.15 27.77.19" />
    </G>
  );
}

export default HeadbandYellow;
